import react from "../../images/react.png";
import router from "../../images/react router.png";
import material from "../../images/material.png";

export const blogs = [
  {
    image: react,
    name: "Introduction to React",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repudiandae rerum in aspernatur eius adipisci. Quam harum deleniti quos, impedit doloremque eveniet totam iusto, aliquid fuga vero incidunt tenetur, assumenda nesciunt!",
    technology: ["React.js"],
    date: new Date().toDateString(),
  },
  {
    image: router,
    name: "Introduction to React Router",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repudiandae rerum in aspernatur eius adipisci. Quam harum deleniti quos, impedit doloremque eveniet totam iusto, aliquid fuga vero incidunt tenetur, assumenda nesciunt!",
    technology: ["React.js", "React Router"],
    date: new Date().toDateString(),
  },
  {
    image: material,
    name: "Introduction to Material-UI",
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repudiandae rerum in aspernatur eius adipisci. Quam harum deleniti quos, impedit doloremque eveniet totam iusto, aliquid fuga vero incidunt tenetur, assumenda nesciunt!",
    technology: ["React.js", "Material-UI"],
    date: new Date().toDateString(),
  },
];
